module.exports = __webpack_public_path__ + "img/sealBox3.7b5d6201.png";